module.exports = __webpack_public_path__ + "static/media/icon-x-light.94353594.svg";